import Button from '@mui/material/Button';
import { styled as muiStyled } from '@mui/material/styles';

const buttonCommonStyle = {
  fontSize: '16px',
  flex: 1,
  height: '48px',
  borderRadius: '4px',
  lineHeight: '48px',
  textAlign: 'center',
  textTransform: 'none',
  fontWeight: 700,
  boxSizing: 'border-box',
};

export const NotifyButton = muiStyled(Button)({
  ...buttonCommonStyle,
  // @ts-ignore
  border: '1px solid #1A1A1A',
  backgroundColor: '#FFFFFF',
  color: '#1A1A1A',
  '&:hover': {
    backgroundColor: '#f0f1f4',
    '&:active': {
      backgroundColor: '#e6e8ed'
    },
    // color: '#990915',
    // borderColor: '#990915',
    // backgroundColor: '#FFFFFF',
    boxShadow: 'none',
  },
  '&.Mui-disabled': {
    opacity: 0.5,
    cursor: 'no-drop',
    color: '#C2C4CC',
    borderColor: '#C2C4CC',
    backgroundColor: 'transparent',
  },
});

export const ReserveButton = muiStyled(Button)({
  ...buttonCommonStyle,
  // @ts-ignore
  border: '1.5px solid rgba(0, 0, 0, 0.92)',
  backgroundColor: '#FFFFFF',
  color: '#1A1A1A',
  fontWeight: 700,
  '&:hover': {
    color: '#990915',
    borderColor: '#990915',
    boxShadow: 'none',
  },
  '&.Mui-disabled': {
    opacity: 0.5,
    cursor: 'no-drop',
    color: '#888B94',
    backgroundColor: '#FFFFFF',
    fontWeight: 500,
    borderColor: 'var(--sys-Text-Disable)',
  },
});

export const AddCartButton = muiStyled(Button)({
  ...buttonCommonStyle,
  // @ts-ignore
  backgroundColor: '#1A1A1A',
  color: '#fff',
  '&:hover': {
    backgroundColor: '#272727',
    boxShadow: 'none',
    '&:active': {
      backgroundColor: '#303030',
    }
  },
  '&.Mui-disabled': {
    opacity: 0.5,
    cursor: 'no-drop',
    color: '#C2C4CC',
    backgroundColor: '#000000BF',
  },
});

export const BuyNowButton = muiStyled(Button)({
  ...buttonCommonStyle,
  // @ts-ignore
  color: '#fff',
  backgroundColor: '#CC0C1C',
  '&:hover': {
    // borderColor: '#990915',
    backgroundColor: '#cf1a29',
    boxShadow: 'none',
    '&:active': {
      backgroundColor: '#d12432',
    }
  },
  '&.Mui-disabled': {
    opacity: 0.5,
    cursor: 'no-drop',
    color: '#fff',
    borderColor: '#FF9FA7',
    backgroundColor: '#FF9FA7',
  },
});
